module.exports = __webpack_public_path__ + "static/media/icon.d2209a64.png";